/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContact } from '../../models/api-response-contact';
import { Contact } from '../../models/contact';

export interface CreateContact$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Contact
}

export function createContact(http: HttpClient, rootUrl: string, params: CreateContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContact>> {
  const rb = new RequestBuilder(rootUrl, createContact.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContact>;
    })
  );
}

createContact.PATH = '/v1/api/ui/contacts';
